/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { SlotsLib, SlotsLibInterface } from "../SlotsLib";

const _abi = [
  {
    inputs: [],
    name: "SLOT_LIB_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class SlotsLib__factory {
  static readonly abi = _abi;
  static createInterface(): SlotsLibInterface {
    return new Interface(_abi) as SlotsLibInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): SlotsLib {
    return new Contract(address, _abi, runner) as unknown as SlotsLib;
  }
}
